import { render, staticRenderFns } from "./LayoutEditor.vue?vue&type=template&id=3794a3ed&scoped=true"
import script from "./LayoutEditor.vue?vue&type=script&lang=js"
export * from "./LayoutEditor.vue?vue&type=script&lang=js"
import style0 from "./LayoutEditor.vue?vue&type=style&index=0&id=3794a3ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3794a3ed",
  null
  
)

export default component.exports